(() => {
  const SELECTORS = {
    product: 'product-information, .product-details--form-wrapper',
    title: '.product-details-product-title',
    price: '.product-price-group .money',
    purchase: '.paymentButtonsWrapper',
    button: '.paymentButtonsWrapper button[type="submit"], .paymentButtonsWrapper .product--add-to-cart-button'
  };

  const MOBILE_QUERY = '(max-width: 989px)';

  function initStickyPurchaseBar() {
    if (!document.body.classList.contains('template-product')) return;
    if (document.querySelector('[data-ag-pdp-sticky]')) return;

    const bar = document.createElement('aside');
    bar.className = 'ag-pdp-sticky';
    bar.dataset.agPdpSticky = '';
    bar.setAttribute('aria-label', 'Product purchase controls');
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = `
      <div class="ag-pdp-sticky__inner">
        <div class="ag-pdp-sticky__summary">
          <span class="ag-pdp-sticky__eyebrow">Your Folly ritual</span>
          <strong class="ag-pdp-sticky__title"></strong>
          <span class="ag-pdp-sticky__price"></span>
        </div>
        <button class="ag-pdp-sticky__button" type="button"></button>
      </div>
    `;

    document.body.appendChild(bar);

    const title = bar.querySelector('.ag-pdp-sticky__title');
    const price = bar.querySelector('.ag-pdp-sticky__price');
    const button = bar.querySelector('.ag-pdp-sticky__button');
    const mobile = window.matchMedia(MOBILE_QUERY);
    let sourceButton = null;
    let sourcePurchase = null;
    let sourceIsVisible = false;
    let intersectionObserver = null;

    const visibleMoney = () => {
      const prices = [...document.querySelectorAll(SELECTORS.price)];
      return prices.find((node) => {
        const style = window.getComputedStyle(node);
        return style.display !== 'none' && style.visibility !== 'hidden';
      }) || prices[0];
    };

    const setVisible = (visible) => {
      const shouldShow = Boolean(visible && mobile.matches && sourceButton);
      bar.classList.toggle('is-visible', shouldShow);
      bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      document.body.classList.toggle('ag-pdp-sticky-visible', shouldShow);
    };

    const syncContent = () => {
      const sourceTitle = document.querySelector(SELECTORS.title);
      const sourcePrice = visibleMoney();
      const visibleButtonText = sourceButton
        ? [...sourceButton.children]
          .filter((node) => {
            const style = window.getComputedStyle(node);
            return node.tagName !== 'SVG'
              && !node.classList.contains('sr-only')
              && style.display !== 'none'
              && style.visibility !== 'hidden';
          })
          .map((node) => node.textContent?.trim())
          .filter(Boolean)
          .join(' ')
        : '';
      const buttonText = visibleButtonText
        || sourceButton?.innerText?.trim().replace(/\s+/g, ' ')
        || 'View product';
      const disabled = !sourceButton || sourceButton.disabled || sourceButton.getAttribute('aria-disabled') === 'true';

      title.textContent = sourceTitle?.textContent?.trim() || 'Folly skincare';
      price.textContent = sourcePrice?.textContent?.trim() || '';
      button.textContent = buttonText;
      button.disabled = disabled;
      button.classList.toggle('is-disabled', disabled);
      button.setAttribute('aria-label', `${buttonText}: ${title.textContent}`);
    };

    const bindPurchaseControl = () => {
      const nextButton = document.querySelector(SELECTORS.button);
      const nextPurchase = nextButton?.closest(SELECTORS.purchase) || null;

      if (nextButton === sourceButton && nextPurchase === sourcePurchase) {
        syncContent();
        setVisible(!sourceIsVisible);
        return;
      }

      intersectionObserver?.disconnect();
      sourceButton = nextButton;
      sourcePurchase = nextPurchase;
      sourceIsVisible = false;

      if (sourcePurchase) {
        intersectionObserver = new IntersectionObserver(([entry]) => {
          sourceIsVisible = entry.isIntersecting;
          setVisible(!sourceIsVisible);
        }, { threshold: 0.15 });
        intersectionObserver.observe(sourcePurchase);
      }

      syncContent();
      setVisible(!sourceIsVisible);
    };

    button.addEventListener('click', () => {
      bindPurchaseControl();
      if (!sourceButton || sourceButton.disabled) return;
      sourceButton.click();
    });

    const productRoot = document.querySelector(SELECTORS.product) || document.body;
    const mutationObserver = new MutationObserver(bindPurchaseControl);
    mutationObserver.observe(productRoot, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'class']
    });

    mobile.addEventListener?.('change', () => setVisible(!sourceIsVisible));
    bindPurchaseControl();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyPurchaseBar, { once: true });
  } else {
    initStickyPurchaseBar();
  }

  document.addEventListener('shopify:section:load', initStickyPurchaseBar);
})();
